export class ExportOrganizationCostDataRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "costUnit",
            "baseName": "costUnit",
            "type": "CostUnit",
            "format": ""
        },
        {
            "name": "usageUnit",
            "baseName": "usageUnit",
            "type": "UsageUnit",
            "format": ""
        },
        {
            "name": "timeFrame",
            "baseName": "timeFrame",
            "type": "TimeFrame",
            "format": ""
        },
        {
            "name": "granularity",
            "baseName": "granularity",
            "type": "CostGranularity",
            "format": ""
        },
        {
            "name": "filters",
            "baseName": "filters",
            "type": "OrgCostDataFilters",
            "format": ""
        },
        {
            "name": "groupBy",
            "baseName": "groupBy",
            "type": "OrgCostDataGroupBy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ExportOrganizationCostDataRequest.attributeTypeMap;
    }
    constructor() {
    }
}
